var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visible
    ? _c(
        "div",
        {
          staticClass: "album-download-progress-overlay album-studio-progress",
          attrs: {
            role: "dialog",
            "aria-modal": "true",
            "aria-live": "polite",
          },
        },
        [
          _c(
            "div",
            { staticClass: "album-download-progress-card" },
            [
              _c("i", {
                staticClass:
                  "el-icon-loading album-download-progress-card__icon",
              }),
              _c("h3", { staticClass: "album-download-progress-card__title" }, [
                _vm._v(_vm._s(_vm.title)),
              ]),
              _c(
                "p",
                { staticClass: "album-download-progress-card__message" },
                [_vm._v(_vm._s(_vm.message))]
              ),
              _vm.indeterminate
                ? _c(
                    "div",
                    {
                      staticClass: "album-progress-indeterminate",
                      attrs: { role: "progressbar", "aria-label": _vm.title },
                    },
                    [_c("span")]
                  )
                : _c("el-progress", {
                    staticClass: "album-download-progress-card__bar",
                    attrs: {
                      percentage: _vm.safePercentage,
                      "show-text": false,
                      color: _vm.colors,
                    },
                  }),
              !_vm.indeterminate
                ? _c(
                    "div",
                    { staticClass: "album-download-progress-card__percent" },
                    [_vm._v(_vm._s(_vm.safePercentage) + "%")]
                  )
                : _vm._e(),
              _c("p", { staticClass: "album-download-progress-card__note" }, [
                _vm._v(
                  _vm._s(
                    _vm.indeterminate
                      ? "Khi bắt đầu tải, bạn có thể theo dõi tiến trình trong trình duyệt."
                      : "Vui lòng không đóng trang trong quá trình tải."
                  )
                ),
              ]),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }